"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SheetHeader = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const overlay_styles_1 = require("@/components/overlay/overlay.styles");
require("@/components/common");
let SheetHeader = class SheetHeader extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.heading = '';
        // 헤더는 늘 시트의 직계 자식으로 쓰이므로, 요청 이벤트를 따로 두지 않고 담은 시트를 직접 닫는다.
        this.handleClose = () => {
            this.closest('mm-sheet')?.close();
        };
    }
    render() {
        return (0, lit_1.html) `
      <mm-heading level="3">${this.heading}</mm-heading>
      <mm-close-button @close=${this.handleClose}></mm-close-button>
    `;
    }
};
SheetHeader.styles = overlay_styles_1.sheetHeaderStyles;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SheetHeader.prototype, "heading", void 0);
SheetHeader = __decorate([
    (0, decorators_js_1.customElement)('mm-sheet-header')
], SheetHeader);
exports.SheetHeader = SheetHeader;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hlZXQtaGVhZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic2hlZXQtaGVhZGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFzQztBQUN0QyxxREFBMkQ7QUFJM0Qsd0VBQXVFO0FBQ3ZFLCtCQUE0QjtBQUdyQixJQUFNLFdBQVcsR0FBakIsTUFBTSxXQUFZLFNBQVEsZ0JBQVU7SUFBcEM7O1FBRXVCLFlBQU8sR0FBRyxFQUFFLENBQUE7UUFTeEMsMERBQTBEO1FBQ2xELGdCQUFXLEdBQUcsR0FBRyxFQUFFO1lBQ3pCLElBQUksQ0FBQyxPQUFPLENBQVEsVUFBVSxDQUFDLEVBQUUsS0FBSyxFQUFFLENBQUE7UUFDMUMsQ0FBQyxDQUFBO0lBQ0gsQ0FBQztJQVhDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzhCQUNlLElBQUksQ0FBQyxPQUFPO2dDQUNWLElBQUksQ0FBQyxXQUFXO0tBQzNDLENBQUE7SUFDSCxDQUFDOztBQVJNLGtCQUFNLEdBQUcsa0NBQWlCLENBQUE7QUFDTDtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7NENBQWE7QUFGN0IsV0FBVztJQUR2QixJQUFBLDZCQUFhLEVBQUMsaUJBQWlCLENBQUM7R0FDcEIsV0FBVyxDQWV2QjtBQWZZLGtDQUFXIn0=